import { css } from "@emotion/react";
import React from "react";
import { useTheme } from "../theme";

export interface PanelProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * 文字色を灰色に、取り消し線を装飾することでそのPanelが無効化された状態にあることを示します。
   *
   * @default false
   */
  disabled?: boolean;
  /**
   * 右側に任意の要素を挿入します。アイコンのような小さな要素を入れることを想定しています。
   */
  icon?: React.ReactNode;
  /**
   * 中身のコンポーネントを任意のHTML要素またはReact.Componentに切り替えます。
   *
   * @default div
   */
  as?: React.ElementType;

  children?: React.ReactNode;
}

/**
Panelコンポーネントはテキストと任意のアイコンのみによる単純な区切りを表すものとして設計しています。
見出し要素などを入れる場合は別のModalやPaperなどのコンポーネントを検討してください。
*/
export const Panel = ({
  as = "div",
  children,
  disabled,
  icon,
  className,
  ...props
}: PanelProps) => {
  const theme = useTheme();
  const Component = as;
  return (
    <Component
      data-disabled={disabled ? "" : undefined}
      css={css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: ${theme.spacing * 3}px 1em;
        border: 1px solid ${theme.palette.action.disabled};
        & + & {
          border-top: none;
        }
        &[data-disabled] {
          color: ${theme.palette.text.disabled};
          text-decoration: line-through;
        }
      `}
      className={className}
      {...props}
    >
      {
        <div
          css={css`
            margin-right: ${theme.spacing * 2}px;
          `}
        >
          {children}
        </div>
      }
      {icon}
    </Component>
  );
};
